import { render, staticRenderFns } from "./editNew.vue?vue&type=template&id=b6ddd1e2&scoped=true"
import script from "./editNew.vue?vue&type=script&lang=js"
export * from "./editNew.vue?vue&type=script&lang=js"
import style0 from "./editNew.vue?vue&type=style&index=0&id=b6ddd1e2&prod&lang=scss"
import style1 from "./editNew.vue?vue&type=style&index=1&id=b6ddd1e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ddd1e2",
  null
  
)

export default component.exports